import { Result } from '@gametailors/web-core/classes';

/**
 * Sends reports of what was answered one at a time, in the order they were made. Fire-and-forget: a report that fails is
 * logged and dropped, so it never holds up whoever made it, and the next one goes out regardless.
 */
export class AnswerReportQueue {
  /** The report being sent, if any. */
  private pending: Promise<void> = Promise.resolve();

  /** Sends a report, by calling `send`, once every report enqueued before it has been answered. */
  enqueue(send: () => Promise<Result<unknown, unknown>>): void {
    this.pending = this.pending
      .then(send)
      .then((response) => {
        if (response.isErr()) {
          console.error('Failed to report answers', response.unwrapErr());
        }
      })
      .catch((e) => console.error('Failed to report answers', e));
  }
}
